import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

export const FeeTrendChart = ({ data = [], dataKey = "monthly_fee", height = 260, testid = "fee-trend-chart" }) => (
  <div style={{ height }} data-testid={testid} role="img" aria-label={`Fee trend chart from ${data[0]?.year} to ${data[data.length - 1]?.year}`}>
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
        <defs>
          <linearGradient id="feeFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#03A896" stopOpacity={0.35} />
            <stop offset="100%" stopColor="#03A896" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
        <XAxis dataKey="year" tick={{ fontSize: 12, fill: "#475569" }} tickLine={false} axisLine={false} />
        <YAxis tick={{ fontSize: 12, fill: "#475569" }} tickLine={false} axisLine={false} tickFormatter={(v) => `$${v}`} />
        <Tooltip formatter={(v) => [`$${v}/mo`, "Avg. monthly fee"]} contentStyle={{ borderRadius: 12, border: "1px solid #E2E8F0" }} />
        <Area type="monotone" dataKey={dataKey} stroke="#03A896" strokeWidth={2.5} fill="url(#feeFill)" dot={{ r: 3, fill: "#0B2150" }} />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);
